<template>
  <b-row>
    <b-col class="content">
      <h5 class="search-title">Intern</h5>
      <iframe
        :src="url"
        style="border:none; width: 100%; min-height: 600px; height: 100%; position: relative; top: -13px;" id="iframe-hh-249"></iframe>
    </b-col>
  </b-row>
</template>

<script>
import authMixin from './shared/mixins/auth'
export default {
  mixins: [authMixin],
  computed: {
    url () {
      let url = '//api.helloholidays.ro/b2b/turismintern.html'
      url += '?data=' + encodeURI(this.userData.jwt)
      return url
    }
  }
}
</script>
